var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mx-4 mt-4 mb-2",attrs:{"shaped":"","elevation":"12","outlined":""}},[_c('iframe',{attrs:{"src":_vm.getIframeSource,"frameborder":"0","width":"100%","height":"700"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }